import { getInsurances,searchInsurances} from '@/services/endpoints/insurances'
import {searchServiceProperties} from "@/services/endpoints/serviceProperties";
import statuses from "@/constatnts/statuses";

export default {
    async getInsurances({commit}) {
        try {
            let res = await getInsurances();
            if(res) {
                commit('SET_INSURANCES', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },

    async getActiveInsurances({ commit }) {
        try {
            let res = await searchInsurances({status: statuses.ACTIVE});
            if(res) {
                commit('SET_INSURANCES', res.data.data)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
}